/** The docked Tools panel's width beside the video (web). */
export const INTERPRETER_TOOLS_PANEL_WIDTH = 320;
/**
 * From this window width the Tools panel docks beside the video and the video
 * narrows by its width; below it the panel is a sheet over the bottom of the
 * screen, capped so the client's video stays visible above it.
 */
export const INTERPRETER_TOOLS_DOCK_MIN_WIDTH = 720;
/** The element the Tools key controls. */
export const INTERPRETER_TOOLS_PANEL_ID = 'interpreter-tools-panel';
